import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';
import TimeframePicker from '@components/TimeframePicker';
import { RadioButtonsGroup } from '@components/RadioButtonsGroup';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 564,
        '@media (max-width: 600px)': {
            height: 'var(--100vh)',
            width: '100%',
        },
    },
    '& .modal-base-content': {
        padding: '24px 16px',
    },
});

export const Content = styled('div')({
    display: 'grid',
    gridGap: '8px 24px',
    gridTemplateColumns: '100%',
    overflowX: 'initial',
    '@media (max-width: 768px)': {
        gridTemplateColumns: '100%',
        gridGap: '8px',
    },
});

export const StyledTimeframePicker = styled(TimeframePicker)({
    width: 'calc(50% - 4px)',
});

export const RadioButtonsWrapper = styled('div')({
    overflowX: 'auto',
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
        display: 'none',
    },
    '@media (max-width: 768px)': {
        overflowX: 'auto',
    },
});

export const StyledRadioButtons = styled(RadioButtonsGroup)({
    marginTop: '8px',
    marginBottom: '16px',
    width: 'max-content',
    '& .MuiFormControlLabel-root': {
        flex: 'initial',
    },
});

export const TypeContainer = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'calc(50% - 4px) calc(25% - 16px) calc(25% - 16px)',
    gap: '16px',
    '@media (max-width: 768px)': {
        gridTemplateColumns: '100%',
        gap: '8px',
    },
});
